(() => {
  if (window.__jelriCartRescue20260622 || typeof window.fetch !== "function") return;
  window.__jelriCartRescue20260622 = true;
  const originalFetch = window.fetch.bind(window);
  const cartPaths = new Set(["/cart.js", "/cart.json", "/cart/add.js", "/cart/change.js", "/cart/update.js", "/cart/clear.js"]);
  const cartReadPaths = new Set(["/cart.js", "/cart.json"]);
  const cartCacheKey = "jelri:last-valid-cart";
  const delay = (ms) => new Promise((resolve) => window.setTimeout(resolve, ms));
  const getUrl = (input) => {
    const rawUrl = typeof input === "string" ? input : input && input.url;
    if (!rawUrl) return null;
    try { return new URL(rawUrl, window.location.href); } catch (error) { return null; }
  };
  const isCartRequest = (input) => {
    const url = getUrl(input);
    return Boolean(url && url.origin === window.location.origin && cartPaths.has(url.pathname));
  };
  const emptyCart = () => ({ items: [], item_count: 0 });
  const normalizeCart = (cart) => {
    if (!cart || !Array.isArray(cart.items)) return emptyCart();
    if (typeof cart.item_count !== "number") cart.item_count = cart.items.reduce((sum, item) => sum + Number(item.quantity || 0), 0);
    return cart;
  };
  const readCartCache = () => {
    try { return normalizeCart(JSON.parse(window.sessionStorage.getItem(cartCacheKey) || window.localStorage.getItem("cart") || "null")); }
    catch (error) { return emptyCart(); }
  };
  const writeCartCache = (cart) => {
    const normalized = normalizeCart(cart);
    try { window.sessionStorage.setItem(cartCacheKey, JSON.stringify(normalized)); } catch (error) {}
    try { window.localStorage.setItem("cart", JSON.stringify(normalized)); } catch (error) {}
    return normalized;
  };
  const cacheCartFromResponse = (response) => {
    if (!response || !response.ok || response.headers.get("content-type")?.includes("text/html")) return;
    response.clone().json().then((cart) => {
      if (cart && Array.isArray(cart.items)) writeCartCache(cart);
    }).catch(() => {});
  };
  const cartJsonResponse = (cart, status) => new Response(JSON.stringify(normalizeCart(cart)), {
    status: 200,
    headers: {
      "content-type": "application/json",
      "x-jelri-cart-rescue": "cached-cart",
      "x-jelri-original-status": String(status || 0)
    }
  });
  const shouldRetry = (response) => Boolean(response && (
    response.status === 429 ||
    response.status === 503 ||
    response.headers.get("cf-mitigated") === "challenge" ||
    response.headers.get("x-jelri-cart-guard") === "challenge" ||
    response.headers.get("x-jelri-cart-guard") === "html-error" ||
    response.headers.get("content-type")?.includes("text/html")
  ));
  window.fetch = async function jelriCartRescueFetch(input, init) {
    const cartRequest = isCartRequest(input);
    const url = getUrl(input);
    let response = await originalFetch(input, init);
    if (!cartRequest) return response;
    // Do not retry cart requests: retries can duplicate mutations and amplify Cloudflare challenges.
    if (shouldRetry(response)) {
      window.dispatchEvent(new CustomEvent("jelri:cart-request-blocked", { detail: { status: response.status, path: url && url.pathname } }));
      if (url && cartReadPaths.has(url.pathname) && typeof Response === "function") return cartJsonResponse(readCartCache(), response.status);
    }
    cacheCartFromResponse(response);
    return response;
  };
  writeCartCache(readCartCache());
  const disabledClass = () => (window.themeCore && window.themeCore.utils && window.themeCore.utils.cssClasses && window.themeCore.utils.cssClasses.disabled) || "is-disabled";
  const syncInput = (input) => {
    if (!input) return;
    const wrapper = input.closest(".js-product-quantity");
    if (!wrapper) return;
    const value = Number(input.value || 0);
    const min = Number(input.getAttribute("min") || 0);
    const maxAttr = input.getAttribute("max");
    const max = maxAttr ? Number(maxAttr) : Infinity;
    const decrease = wrapper.querySelector("[data-quantity-decrease]");
    const increase = wrapper.querySelector("[data-quantity-increase]");
    const cls = disabledClass();
    if (decrease) { decrease.toggleAttribute("disabled", value <= min); decrease.classList.toggle(cls, value <= min); }
    if (increase) { increase.toggleAttribute("disabled", value >= max); increase.classList.toggle(cls, value >= max); }
  };
  const syncAll = () => document.querySelectorAll("[data-quantity-input-additional]").forEach(syncInput);
  const scheduleSync = () => { window.requestAnimationFrame(syncAll); window.setTimeout(syncAll, 120); window.setTimeout(syncAll, 500); };
  document.addEventListener("click", (event) => {
    if (event.target.closest("[data-quantity-decrease], [data-quantity-increase], .js-product-quantity, .js-sticky-add-to-cart")) scheduleSync();
  }, true);
  document.addEventListener("input", (event) => {
    if (event.target.matches("[data-quantity-input], [data-quantity-input-additional]")) scheduleSync();
  }, true);
  document.addEventListener("theme:all:loaded", scheduleSync);
  document.addEventListener("product:loaded", scheduleSync);
  scheduleSync();

  const moneyFormat = (cents) => {
    try {
      return new Intl.NumberFormat("es-MX", { style: "currency", currency: "MXN" }).format(Number(cents || 0) / 100).replace("$", "MXN ");
    } catch (error) {
      return "MXN " + (Number(cents || 0) / 100).toFixed(2);
    }
  };

  const visibleGroups = () => Array.from(document.querySelectorAll(".wizz4-cart-drawer.wizz4-visible .wizz-product-content-buttonGroup-custom"));
  const groupButtons = (group) => Array.from(group.children).filter((child) => child.tagName === "DIV");
  const groupInput = (group) => group.querySelector("input");

  const recordWizzError = (error) => {
    window.__jelriWizzQuantityErrors = window.__jelriWizzQuantityErrors || [];
    window.__jelriWizzQuantityErrors.push({
      message: error && error.message ? error.message : String(error),
      at: new Date().toISOString()
    });
  };

  const recordWizzAction = (detail) => {
    window.__jelriWizzQuantityLastAction = {
      ...detail,
      at: new Date().toISOString()
    };
  };

  async function readCanonicalCart() {
    const response = await originalFetch("/cart.js", { headers: { "accept": "application/json" } });
    if (!response.ok || response.headers.get("content-type")?.includes("text/html")) {
      throw new Error("Cart read failed: " + response.status);
    }
    const cart = normalizeCart(await response.json());
    writeCartCache(cart);
    return cart;
  }

  async function changeCartLine(item, line, quantity) {
    const payload = item && item.key ? { id: item.key, quantity } : { line, quantity };
    const response = await originalFetch("/cart/change.js", {
      method: "POST",
      headers: { "content-type": "application/json", "accept": "application/json" },
      body: JSON.stringify(payload)
    });

    if (!response.ok || response.headers.get("content-type")?.includes("text/html")) {
      throw new Error("Cart change failed: " + response.status);
    }

    const cart = normalizeCart(await response.json());
    writeCartCache(cart);
    return cart;
  }

  function updateWizzDrawer(cart, group, lineIndex, quantity) {
    const drawer = group.closest(".wizz4-cart-drawer");
    const item = cart.items[lineIndex];
    const input = groupInput(group);
    if (input) input.value = String(quantity);

    if (drawer) {
      drawer.querySelectorAll(".wizz-header-title-custom").forEach((title) => {
        title.textContent = title.textContent.replace(/\(\d+\)/, "(" + cart.item_count + ")");
      });

      const productLine = group.closest(".wizz-product-custom");
      if (productLine && item) {
        productLine.querySelectorAll(".wizz-product-price-originalPrice-custom").forEach((node) => {
          node.textContent = moneyFormat(item.original_line_price || item.line_price);
        });
        productLine.querySelectorAll(".wizz-product-price-Price-custom").forEach((node) => {
          node.textContent = moneyFormat(item.final_line_price || item.line_price);
        });
        const saving = Number(item.original_line_price || item.line_price) - Number(item.final_line_price || item.line_price);
        productLine.querySelectorAll(".wizz-product-price-saving-custom").forEach((node) => {
          if (saving > 0) node.textContent = "Guardar " + moneyFormat(saving);
        });
      }

      drawer.querySelectorAll(".wizz-checkout-button").forEach((button) => {
        button.textContent = button.textContent.replace(/MXN\s*[\d,.]+/, moneyFormat(cart.total_price || cart.items_subtotal_price));
      });
    }

    window.dispatchEvent(new CustomEvent("cart_changed", { detail: { added: [], removed: [] } }));
    document.dispatchEvent(new CustomEvent("cart:updated", { detail: { cart } }));
  }

  const handleWizzQuantityClick = async (event) => {
    if (event.__jelriWizzQuantityHandled) return;
    const group = event.target.closest(".wizz4-cart-drawer.wizz4-visible .wizz-product-content-buttonGroup-custom");
    if (!group) return;

    const input = groupInput(group);
    const isDecrease = event.target.closest(".wizz-product-content-buttonGroup-decr-custom");
    const isIncrease = event.target.closest(".wizz-product-content-buttonGroup-incr-custom");
    const direction = isDecrease ? -1 : isIncrease ? 1 : 0;
    if (!direction || !input) return;

    event.__jelriWizzQuantityHandled = true;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    const groups = visibleGroups();
    const lineIndex = groups.indexOf(group);
    if (lineIndex < 0) return;

    let previousQuantity = Math.max(0, Number(input.value || 0));

    try {
      const cartBefore = await readCanonicalCart();
      const item = cartBefore.items[lineIndex] || null;
      const currentQuantity = Math.max(0, Number((item && item.quantity) || input.value || 0));
      previousQuantity = currentQuantity;
      const nextQuantity = Math.max(0, currentQuantity + direction);
      input.value = String(nextQuantity);
      recordWizzAction({
        lineIndex,
        direction,
        currentQuantity,
        nextQuantity,
        itemKey: item && item.key,
        cartBeforeCount: cartBefore.item_count
      });
      const cart = await changeCartLine(item, lineIndex + 1, nextQuantity);
      recordWizzAction({
        lineIndex,
        direction,
        currentQuantity,
        nextQuantity,
        itemKey: item && item.key,
        cartBeforeCount: cartBefore.item_count,
        cartAfterCount: cart.item_count
      });
      updateWizzDrawer(cart, group, lineIndex, nextQuantity);
    } catch (error) {
      input.value = String(previousQuantity);
      recordWizzError(error);
    }
  };

  window.addEventListener("click", handleWizzQuantityClick, true);
  document.addEventListener("click", handleWizzQuantityClick, true);
})();
